import { Injectable } from '@angular/core';

import { apiName } from "./data.service";
import { RestService } from "../../../../core/services/rest.service";

@Injectable()
export class EstadoApiService {

  constructor(
    private _restService: RestService
  ) { }

  onGetAll(done: any) {
    var filter: any = {"where":{"ativo":true},"order":"nome"};
    this._restService.onGetPost(apiName, filter, done);
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/enderecos/estados/shared/estado-api.service.ts
 **/